'use client';

import { useEffect, useState, type RefObject } from 'react';

// Width of the element in CSS pixels, following resizes. Starts at `fallback` because the
// server cannot measure; the real width lands on the first client frame.
export function useBoxWidth(ref: RefObject<HTMLElement | null>, fallback: number): number {
  const [width, setWidth] = useState(fallback);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new ResizeObserver(([entry]) => {
      const measured = Math.round(entry.contentRect.width);
      if (measured > 0) setWidth(measured);
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return width;
}
